module.exports = __webpack_public_path__ + "img/favorite-anim.31abcfa7.svg";